import { CheckIcon, CopyIcon } from 'lucide-react'
import { ReactNode } from 'react'

import { useCopyToClipboard } from '@/hooks/copy-to-clipboard'
import { UiButton } from '@/ui/UiButton'
import {
  UiTooltip,
  UiTooltipContent,
  UiTooltipProvider,
  UiTooltipTrigger,
} from '@/ui/UiTooltip'

type Props = {
  value: string
  label?: ReactNode
  copiedLabel?: ReactNode
  tooltip?: ReactNode
  className?: string
}

export default function CopyButtonWithLabel({
  value,
  label = 'Copy',
  copiedLabel = 'Copied',
  tooltip,
  className,
}: Props) {
  const { copy, isCopied } = useCopyToClipboard()

  const tooltipText = tooltip ?? (isCopied ? copiedLabel : label)

  return (
    <UiTooltipProvider delayDuration={0}>
      <UiTooltip>
        <UiTooltipTrigger asChild>
          <UiButton
            type='button'
            variant='outline'
            size='sm'
            className={className}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              copy(value)
            }}
          >
            {isCopied ? (
              <CheckIcon className='text-primary size-4' />
            ) : (
              <CopyIcon className='text-primary size-4' />
            )}
            <span>{isCopied ? copiedLabel : label}</span>
          </UiButton>
        </UiTooltipTrigger>
        <UiTooltipContent className='max-w-75'>
          <p>{tooltipText}</p>
        </UiTooltipContent>
      </UiTooltip>
    </UiTooltipProvider>
  )
}
